"use client";

import { MessageCircle, Calendar, House as Home } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Process() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: stepsRef,
    isVisible: stepsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const steps = [{
    number: "01",
    title: "Appel découverte gratuit",
    description: "Une première rencontre en visio pour faire connaissance, discuter de ce qui vous tient à cœur et voir si on est faits pour avancer ensemble.",
    Icon: MessageCircle
  }, {
    number: "02",
    title: "Préparation prénatale",
    description: "Nous préparons ensemble votre plan post-partum selon vos envies et vos besoins. Nous échangeons autour du sommeil, de la nutrition, de l'allaitement, du couple, de la création de votre village de soutien... puis la séance se termine par une réflexologie plantaire pour vous chouchouter avant l'arrivée de bébé.",
    Icon: Calendar
  }, {
    number: "03",
    title: "Accompagnement à domicile",
    description: "À chaque visite, je m'adapte à vos besoins : soins corporels, cuisine nourrissante, postures douces, resserrage du bassin, soutien sommeil, allaitement, ménage léger, et surtout une présence et une oreille attentive.",
    Icon: Home
  }];
  return;
}